import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface CollectionsState {
  activeCollectionID: string | null;
  childrenCollectionIDs: string[];
  selectedChildrenCollectionIDs: string[];
}

const initialCollectionsState: CollectionsState = {
  activeCollectionID: null,
  childrenCollectionIDs: [],
  selectedChildrenCollectionIDs: [],
};

export const collectionsSlice = createSlice({
  name: "collections",
  initialState: initialCollectionsState,
  reducers: {
    setActiveCollectionID: (state, action: PayloadAction<string | null>) => {
      state.activeCollectionID = action.payload;
    },
    setChildrenCollectionIDs: (state, action: PayloadAction<string[]>) => {
      state.childrenCollectionIDs = action.payload;
    },
    setSelectedChildrenCollectionIDs: (
      state,
      action: PayloadAction<string[]>,
    ) => {
      state.selectedChildrenCollectionIDs = action.payload;
    },
    addSelectedChildrenCollectionID: (state, action: PayloadAction<string>) => {
      if (!state.selectedChildrenCollectionIDs.includes(action.payload)) {
        state.selectedChildrenCollectionIDs.push(action.payload);
      }
    },
    removeSelectedChildrenCollectionID: (
      state,
      action: PayloadAction<string>,
    ) => {
      state.selectedChildrenCollectionIDs =
        state.selectedChildrenCollectionIDs.filter(
          (id) => id !== action.payload,
        );
    },
  },
});

export const {
  setActiveCollectionID,
  setChildrenCollectionIDs,
  setSelectedChildrenCollectionIDs,
  addSelectedChildrenCollectionID,
  removeSelectedChildrenCollectionID,
} = collectionsSlice.actions;

export const selectActiveCollectionID = (state: RootState) =>
  state.collections.activeCollectionID;

export const selectChildrenCollectionIDs = (state: RootState) =>
  state.collections.childrenCollectionIDs;

export const selectSelectedChildrenCollectionIDs = (state: RootState) =>
  state.collections.selectedChildrenCollectionIDs;

export default collectionsSlice.reducer;
